/**
 * 起飞申请状态。**单点定义在这里,三端引用**(CLAUDE.md 硬约束「枚举单点定义」)。
 *
 * 待审核 / 已通过 / 已驳回,与承运商入驻审核(M-05)同形。
 *
 * **已审核是终态:没有改判** —— 再审核一次返回 409 ILLEGAL_TRANSITION(Y-40);
 * 驳回之后飞手**新建**一条重走流程,不是把这一条改回 pending ——
 * 那次驳回本身是记录,原地复活等于把它抹掉了。
 *
 * prisma/schema.prisma 里有一份同名的数据库枚举,那是不得不有的第二处 ——
 * 数据库需要自己的类型定义。两处的一致性不靠人记得:
 * apps/api/src/common/enum-parity.ts 里有一条类型级断言,两边一旦对不上,
 * `pnpm typecheck` 直接失败(typecheck 守卫会红)。
 * 中文表(待审核 / 已通过 / 已驳回)住在 packages/ui/src/labels.ts,
 * 由 guards/check-enum-labels.mjs 与取值集合逐一对上。
 */
export const TAKEOFF_APPLICATION_STATUS = ['pending', 'approved', 'rejected'] as const

export type TakeoffApplicationStatus = (typeof TAKEOFF_APPLICATION_STATUS)[number]

export function isTakeoffApplicationStatus(x: unknown): x is TakeoffApplicationStatus {
  return typeof x === 'string' && (TAKEOFF_APPLICATION_STATUS as readonly string[]).includes(x)
}
